<app-header></app-header>
<app-top></app-top>
<app-middle-section></app-middle-section>
<app-down-section></app-down-section>
<app-footer></app-footer>